import React from "react";
import { ReactComponent as LargeShopifyLoader } from "../../assets/images/LargeShopifyLoader.svg";

import { useShopifyApp } from "../../hooks/useShopifyApp";

import { Container, Loader, Text, Wrapper } from "./styles";

const LoadingModal = ({ isLoading }) => {
  const isShopifyApp = useShopifyApp();

  if (isLoading) {
    return (
      <Container loading={isLoading ? 1 : 0} $isShopify={isShopifyApp}>
        <Wrapper>
          {isShopifyApp ? (
            <div className="sp-loader">
              <LargeShopifyLoader />
            </div>
          ) : (
            <>
              <Loader />
              <Text>Please wait...</Text>
            </>
          )}
        </Wrapper>
      </Container>
    );
  }

  return null;
};

export default LoadingModal;
